import { buildQueryString, get, request } from "core-web/libs/GrebbCommerceAPI/util";
import { startsWithLocalePrefix } from "core-web/utils/checkForLocalePrefix";

import { API_URL } from "core-web/constants";

const US_ORIGINS = ["beta.wallmektools.com", "www.wallmektools.com"];

export default async (url, parameters = {}, origin, path) => {
    // Build parameters.
    const builtParameters = buildQueryString(parameters);

    if (process.env.REACT_APP_URL) {
        url = process.env.REACT_APP_URL;
    }

    const isUSOrigin = US_ORIGINS.includes(origin);

    const hasLocalePrefix = startsWithLocalePrefix(url);
    if (path && !hasLocalePrefix && !isUSOrigin) {
        url = url + path;
    } else if (path && !hasLocalePrefix && isUSOrigin) {
        url = url + "/en" + path;
    }

    const requestUrl = `/frontend/content/resolve-app?url=${encodeURIComponent(url)}${
        builtParameters && `&${builtParameters}`
    }`;

    let response;
    if (!API_URL && origin) {
        response = await request({
            method: "GET",
            path: requestUrl,
            baseUrl: origin,
        });
        if (response) {
            return await response.body();
        }
    }

    response = await get(requestUrl);

    return await response.body();
};
